<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Rulebook update review</h4>
    <button
      mat-button
      [mat-dialog-close]=""
      (click)="onClose()"
      cdkFocusInitial
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content class="update-review dialog-content">
    @for (sc of data; track sc) {
    <div>
      <h4 class="sectionTitle">
        Section&nbsp;{{sc.rbSectNum}}:&nbsp;{{sc.rbSectName}}
      </h4>
      @for (p of sc.para; track p) {
      <div class="para">
        <div class="b">Para&nbsp;{{p.paraNum}}</div>
        <div [innerHTML]="p.newQuestion"></div>
        <div [innerHTML]="p.newGuidenote"></div>
      </div>
      }
    </div>
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <button
        mat-button
        (click)="onRemoveFlag()"
        class="button-close"
        cdkFocusInitial
      >
        Remove flag
      </button>
      <button
        mat-button
        (click)="onClose()"
        mat-dialog-close
        class="button-close"
      >
        Close
      </button>
    </div>
  </div>
</div>
